export default __webpack_public_path__ + "static/media/travelglobe.b3fade06.png";